import React, {FC, memo} from "react";
import {useLocation} from "react-router-dom";
import {Button} from "antd";
import {BugOutlined, ReadOutlined} from "@ant-design/icons";
import {helpUrlFor} from "../../../models/helpLinks";
import {useSupportReport} from "../../../containers/supportReport/useSupportReport";
import i18n from "../../../services/i18n";

type HelpMenuProps = {
    className?: string;
    /** Doku-Link zur aktuellen Seite, nur mit Tenant-Feature `featureHelpLinks` */
    showPageHelp: boolean;
};

/**
 * Beschriftete Knöpfe im Header, beide beziehen sich auf die gerade geöffnete
 * Seite: „Anleitung zu dieser Seite“ (Doku) und „Fehler melden“. Alles, was
 * nicht von der Seite abhängt (Fernwartung, Kontakt), steht im Hilfe-Center
 * unter dem Menüpunkt „Hilfe“ (containers/help).
 */
const HelpMenu: FC<HelpMenuProps> = ({className, showPageHelp}) => {
    const {pathname} = useLocation();
    const tr = i18n.views.LayoutStandard;
    const {startReport, capturing, drawer} = useSupportReport();

    return (
        <>
            <div className={className} data-testid="help-menu">
                {showPageHelp && (
                    <Button type="text" icon={<ReadOutlined />} href={helpUrlFor(pathname)} target="_blank" rel="noopener noreferrer" title={tr.helpTooltip()}>
                        {tr.helpTooltip()}
                    </Button>
                )}
                <Button type="text" icon={<BugOutlined />} loading={capturing} onClick={startReport} title={tr.reportIssue()}>
                    {tr.reportIssue()}
                </Button>
            </div>
            {drawer}
        </>
    );
};

export default memo(HelpMenu);
